/**
 * Sistema de eventos para comunicação entre componentes de chat
 *
 * Permite que componentes se inscrevam para receber notificações
 * quando sessões de chat são criadas ou atualizadas.
 */

// Nome do evento customizado
export const CHAT_EVENTS = {
  SESSION_CREATED: 'chat:session-created',
  SESSION_UPDATED: 'chat:session-updated',
  SESSIONS_REFRESH: 'chat:sessions-refresh',
} as const;

/**
 * Dispara evento de nova sessão criada
 * Deve ser chamado após criar um novo chat
 */
export const emitSessionCreated = (sessionId?: number) => {
  window.dispatchEvent(
    new CustomEvent(CHAT_EVENTS.SESSION_CREATED, {
      detail: { sessionId, timestamp: Date.now() }
    })
  );
};

/**
 * Dispara evento de sessão atualizada
 * Deve ser chamado após enviar mensagem ou atualizar título
 */
export const emitSessionUpdated = (sessionId: number) => {
  window.dispatchEvent(
    new CustomEvent(CHAT_EVENTS.SESSION_UPDATED, {
      detail: { sessionId, timestamp: Date.now() }
    })
  );
};

/**
 * Dispara evento para forçar refresh da lista de sessões
 */
export const emitSessionsRefresh = () => {
  window.dispatchEvent(
    new CustomEvent(CHAT_EVENTS.SESSIONS_REFRESH, {
      detail: { timestamp: Date.now() }
    })
  );
};
